import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CareerProcessTypeEnum, DiscoveryStatusEnum, UserMinimalData } from '../../services/personal-user-data/personal-user-data';
import { BaseComponent } from '../../base/base.component';
import { AbstractMotivationsService } from '../../services/motivation/motivations.abstract.service';
import { QuickActionSelection } from '../quick-actions/quick-actions/quick-actions.component';
import { ClaroEvents } from '../../services/google-analytics/analytics.enum';
import { IssuesCodes } from 'src/app/make-moov/model/issue-type.enum';

@Component({
  selector: 'app-team-member-card',
  templateUrl: './team-member-card.component.html',
  styleUrls: ['./team-member-card.component.scss']
})
export class TeamMemberCardComponent extends BaseComponent implements OnInit {
  @Input() teamMemberDetails: UserMinimalData;
  @Input() viewType: TeamMemberCardViewType = TeamMemberCardViewType.FULL;
  @Input() presentEmergancyCharge : boolean = false;
  @Input() presentDriverMoovsForTeam: boolean = false;
  @Input() showEnergyLevels: boolean = false;
  @Input() showTotalEnergyLevel : boolean = false;
  @Input() showChatButton: boolean = false;
  @Input() showDetailsButton : boolean = false;
  @Input() isMemberInCareerProcess : boolean = false;
  @Input() presentTotalEnergyBar : boolean = false;
  @Input() highlight: boolean = false;
  @Input() presentLeaderLabel: boolean = false;
  @Output() openDetailsEvent = new EventEmitter();
  @Output() rechargeTeamMemberEvent = new EventEmitter();
  @Output() increateEngagementForTeamMemberEvent = new EventEmitter();
  @Output() driverMoovEvent = new EventEmitter<QuickActionSelection>();
  @Output() openDriverDetailsEvent = new EventEmitter();
  @Output() chatAboutTeamMemberEvent = new EventEmitter();
  
  imageCommonFolder='assets/common/'
  cardHeight : string;
  viewTypeEnum = TeamMemberCardViewType;
  isDiscoveryDone : boolean = false;

  nameInitials: string = "";
  score : number = 0;
  scoreColor : string = "#000000"
  sortedMotivations : string[] = [];

  constructor(public motivationService: AbstractMotivationsService){
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.verifyData();
    this.sortMotivations();
    this.createInitials();
    this.calculateScore();
    this.calculateColor();
    this.initCardHeight();

    // console.log(`in TMC TMD is ${JSON.stringify(this.teamMemberDetails)}`);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ifChanged(changes.viewType, () => this.initCardHeight());
  }

  verifyData() : void{
    this.isDiscoveryDone = this.teamMemberDetails.discoveryStatus == DiscoveryStatusEnum.DONE;
  }

  sortMotivations():void{
    this.sortedMotivations = this.teamMemberDetails.motivations.sort((motivation1, motivation2) => {
      if (this.teamMemberDetails.motivationsGap[motivation1] < this.teamMemberDetails.motivationsGap[motivation2]){
        return 1;
      }
      else if (this.teamMemberDetails.motivationsGap[motivation1] > this.teamMemberDetails.motivationsGap[motivation2]){
        return -1;
      }
      else{
        return 0;
      }
    });
  }

  calculateScore() {
    if (this.teamMemberDetails.discoveryStatus != DiscoveryStatusEnum.DONE){
      return;
    }
    
    this.score = this.teamMemberDetails?.currTotalEnergy * 10 || 0;
    
  }

  createInitials(): void{
    if (this.teamMemberDetails.firstName == "" || this.teamMemberDetails.lastName == ""){
      this.nameInitials = "--";
    }

    this.nameInitials = this.teamMemberDetails.firstName.substring(0, 1) +"."+ this.teamMemberDetails.lastName.substring(0,1);
  }

  initCardHeight(): void{
    if (this.viewType == TeamMemberCardViewType.CLEAN){
      this.cardHeight = '175px';
    }
    else if (this.viewType == TeamMemberCardViewType.MINIMAL){
        this.cardHeight = '220px';      
    }
    else{
      this.cardHeight = '265px';
    }
  }

  getMotivationIconName(motivationId: string): string{
    return this.motivationService.getMotivationIconName(motivationId);
  }

  getMotivationName(motivationId: string): string{
    return this.motivationService.getMotivationName(motivationId);
  }

  calculateColor(){
    if (this.score < 56 ){
      this.scoreColor = '#ED7F95';
    }
    else if (this.score < 86){
      this.scoreColor = '#FFC107'; 
    }
    else {
      this.scoreColor = '#4CAF50';
    }
  }

  getMotivationColor (motivationId: string): string{
    let gapScore = this.teamMemberDetails.motivationsGap[motivationId];

   if (gapScore == 1 || gapScore == 2){
      return '#F43F42';
    }
    else if (gapScore == 3 || gapScore == 4){
      return '#FFC107';
    }
    else {
      return '#4CAF50';
    }
  }

  getMotivationLevel (motivationId: string): number{
    return this.teamMemberDetails.motivationsGap[motivationId];
  }

  openDetails () : void{
    this.analytics.sendClaroEvent(ClaroEvents.TMC_OpenTeamMemberDetails);
    this.openDetailsEvent.emit();
  }

  chatAboutTeamMember(): void{
    this.chatAboutTeamMemberEvent.emit();
  }

  rechargeTeamMember() : void{
    this.analytics.sendClaroEvent(ClaroEvents.TMC_EmergancyRecharge);
    this.rechargeTeamMemberEvent.emit();
  }

  increateEngagementForTeamMember(): void{
    this.analytics.sendClaroEvent(ClaroEvents.TMC_RaiseEnergy);
    this.increateEngagementForTeamMemberEvent.emit();
  }

  driverMoov(motivationId: string): void{
    // this.analytics.sendClaroEvent(ClaroEvents.TMC_Moov);
    
    if (!this.presentDriverMoovsForTeam){
      return;
    }
    let actionId: string = IssuesCodes.teamMemberDriver;
    let selectedAction : QuickActionSelection = {actionId: actionId, motivationId: motivationId};
    this.driverMoovEvent.emit(selectedAction);
  }

  openDriverDetails(motivationId: string): void{
    // this.analytics.sendClaroEvent(ClaroEvents.TMC_OpenDriverDetails);
    this.openDriverDetailsEvent.emit(motivationId);
  }
}

export enum TeamMemberCardViewType{
  CLEAN = 1,
  MINIMAL = 2,
  FULL = 3
}